import { capitalCase } from "change-case";
import moment from "moment";
import ParseDate from "src/components/parse-date";
import swiftParseDate from "src/utils/swift-parse-date";

const forTab = (data, line) => {
  const temp = {};
  temp.Line = line;
  temp["Date"] = swiftParseDate(data?.created_at);
  temp["Name"] =
    data?.user?.user_profile?.first_name + " " + data?.user?.user_profile?.last_name;
   temp["Account ID"] = data?.user?.username;
    temp["Total Sale"] = data?.total_volume;
  return temp;
};

export default forTab;